import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useContext, useEffect, } from 'react';
import cx from 'classnames';
import Context from './Context';
import { useHoverDirty } from '../../hooks/useHoverDirty';
import styles from './Tooltip.module.scss';
const TooltipTarget = ({ children, className, onHover, ...rest }) => {
    const { setRefTarget, refTarget, targetClassName, setIsOpen, triggers, isOpen } = useContext(Context);
    const hovered = useHoverDirty({ current: refTarget });
    const onClick = useCallback(() => {
        if (!isOpen && triggers.includes('click')) {
            setIsOpen(true);
        }
    }, [setIsOpen, triggers, isOpen]);
    useEffect(() => {
        if (!triggers.includes('hover')) {
            return;
        }
        if (hovered && !isOpen) {
            setIsOpen(true);
        }
        if (!hovered && isOpen) {
            setIsOpen(false);
        }
        onHover?.();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hovered, isOpen]);
    return (_jsx("div", { ...rest, className: cx(className, targetClassName, styles.popoverTarget), ref: setRefTarget, onClick: onClick, children: children }));
};
export default Object.assign(memo(TooltipTarget), { displayName: 'TooltipTarget' });
